"use client";

import Layout from "@src/components/common/Layout";
import { selectAuthExpireError, selectAuthToken } from "@src/store/slices/login/selectors";
import Head from "next/head";

import PrivacyPolicyComponents from "../../components/PrivacyPolicy";

import { useAppSelector } from "@src/store/hooks";
const plataformName = `${process.env.NEXT_PUBLIC_PLATAFORM_NAME}`;

const CookiePolicy = () => {
  const authToken = useAppSelector(selectAuthToken);
  const authExpireError = useAppSelector(selectAuthExpireError);
  const isAuth = !!authToken && !authExpireError;
  const pageTitle = `${plataformName} | Políticas de Cookies`;

  const onAuthLinks = [
    { label: "Página inicial", route: "/home" },
    { label: "Políticas de cookies", route: "/cookie-policy", active: true },
  ];

  const offAuthLinks = [
    { label: "Login", route: "/login" },
    { label: "Políticas de cookies", route: "/cookie-policy", active: true },
  ];

  const page = (isAuth: boolean) => {
    return (
      <PrivacyPolicyComponents
        idNotice={process.env.NEXT_PUBLIC_PRIVACY_NOTICE_ID_COOKIE!}
        title="Políticas de Cookies"
        links={isAuth ? onAuthLinks : offAuthLinks}
      />
    );
  };

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      {isAuth ? <Layout>{page(isAuth)}</Layout> : page(isAuth)}
    </>
  );
};

export default CookiePolicy;
